var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_975",
    d: "M8,1.2c3.76,0,6.8,3.04,6.8,6.8s-3.04,6.8-6.8,6.8c-3.76,0-6.8-3.04-6.8-6.8c0,0,0,0,0,0 C1.2,4.25,4.25,1.2,8,1.2 M8,0C3.58,0,0,3.58,0,8s3.58,8,8,8s8-3.58,8-8S12.42,0,8,0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_982",
    transform: "translate(7.211 3.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_976",
    d: "M0.8,1.6C0.36,1.6,0,1.25,0,0.8S0.35,0,0.8,0H0.8c0.44,0,0.8,0.36,0.8,0.8S1.24,1.6,0.8,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_977",
    d: "M0.79,8.73c-0.37,0-0.67-0.3-0.67-0.67c0,0,0,0,0,0V8.05c0-0.18,0-4.12,0-4.3V3.74 c0-0.37,0.3-0.67,0.67-0.67c0.67,0,0.67,0.51,0.67,1.34v2.98C1.46,8.23,1.46,8.73,0.79,8.73z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlack);
export default __webpack_public_path__ + "static/media/infoBlack.4e123e2e41ced0d4f0f6833dfe618f95.svg";
export { ForwardRef as ReactComponent };